import baseAPI from '@/http'

const router = 'api/seloDiagnosticoPerguntas'

export const seloDiagnosticoPerguntasAPI = {

  getPerguntas: () => baseAPI.get(`${router}/obter-diagnostico-perguntas`),
  getSituacaoDiagnostico: (municipioId) => baseAPI.get(`${router}/obter-situacao-diagnostico/${municipioId}`),

}
